// Web mock for @react-native-clipboard/clipboard
const Clipboard = {
  getString: async (): Promise<string> => {
    try {
      return await navigator.clipboard.readText();
    } catch {
      return '';
    }
  },
  setString: (text: string): void => {
    try {
      navigator.clipboard.writeText(text);
    } catch {
      // Fallback using execCommand
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
  },
  hasString: async (): Promise<boolean> => {
    try {
      const text = await navigator.clipboard.readText();
      return text.length > 0;
    } catch {
      return false;
    }
  },
  hasURL: async (): Promise<boolean> => false,
  hasNumber: async (): Promise<boolean> => false,
  hasWebURL: async (): Promise<boolean> => false,
  addListener: () => ({ remove: () => {} }),
  removeAllListeners: () => {},
};

export default Clipboard;
